import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	stats: ReadonlyArray<{ figure: TranslationKey; label: TranslationKey }>;
	align: 'start' | 'center';
}>;

/** The light-gradient card of static figure/label pairs (the figures are translated copy, not live data). */
export const GradientStats: React.FC<Props> = ({ stats, align }) => {
	return (
		<div
			className={cn(
				'bg-gradient-background-light-2 grid grid-cols-[repeat(auto-fit,minmax(min(100%,240px),1fr))] gap-7 rounded-2xl p-7 md:p-10',
				align === 'center' && 'text-center',
			)}
			data-qa="impact-gradient-stats"
		>
			{stats.map(({ figure, label }, index) => (
				// a fixed, never-reordered list of static copy
				<div key={index} className="flex flex-col gap-1">
					<Text variant="heading" size="x-large" fontWeight="bold" className="tabular-nums">
						<TypedTranslate value={figure} />
					</Text>
					<Text as="p" className="text-typography-weak">
						<TypedTranslate value={label} />
					</Text>
				</div>
			))}
		</div>
	);
};
